export default {
  D8: [
    { first: '+ 0,020', second: '+ 0,034' },
    { first: '+ 0,030', second: '+ 0,048' },
    { first: '+ 0,040', second: '+ 0,082' },
    { first: '+ 0,050', second: '+ 0,077' },
    { first: '+ 0,065', second: '+ 0,098' },
    { first: '+ 0,080', second: '+ 0,119' },
    { first: '+ 0,100', second: '+ 0,146' },
    { first: '+ 0,120', second: '+ 0,174' },
    { first: '+ 0,145', second: '+ 0,208' },
    { first: '+ 0,170', second: '+ 0,242' },
  ],
  D9: [
    { first: '+0,020', second: '+0,045' },
    { first: '+0,030', second: '+0,060' },
    { first: '+0,040', second: '+0,076' },
    { first: '+0,050', second: '+0,093' },
    { first: '+0,065', second: '+0,117' },
    { first: '+0,080', second: '+0,142' },
    { first: '+0,100', second: '+0,174' },
    { first: '+0,120', second: '+0,207' },
    { first: '+0,145', second: '+0,245' },
    { first: '+0,170', second: '+0,285' },
  ],
  D10: [
    { first: '+0,020', second: '+0,060' },
    { first: '+0,030', second: '+0,078' },
    { first: '+0,040', second: '+0,098' },
    { first: '+0,050', second: '+0,120' },
    { first: '+0,065', second: '+0,149' },
    { first: '+0,080', second: '+0,180' },
    { first: '+0,100', second: '+0,220' },
    { first: '+0,120', second: '+0,260' },
    { first: '+0,145', second: '+0,305' },
    { first: '+0,170', second: '+0,355' },
  ],
  D11: [
    { first: '', second: '' },
    { first: '+0,030', second: '+0,105' },
    { first: '+0,040', second: '+0,130' },
    { first: '+0,050', second: '+0,160' },
    { first: '+0,065', second: '+0,195' },
    { first: '+0,080', second: '+0,240' },
    { first: '+0,100', second: '+0,290' },
    { first: '+0,120', second: '+0,340' },
    { first: '+0,145', second: '+0,395' },
    { first: '+0,170', second: '+0,460' },
  ],
  E7: [
    { first: '+0,014', second: '+0,024' },
    { first: '+0,020', second: '+0,032' },
    { first: '+0,025', second: '+0,040' },
    { first: '+0,032', second: '+0,050' },
    { first: '+0,040', second: '+0,061' },
    { first: '+0,050', second: '+0,075' },
    { first: '+0,060', second: '+0,090' },
    { first: '+0,072', second: '+0,107' },
    { first: '+0,085', second: '+0,125' },
    { first: '+0,100', second: '+0,146' },
  ],
  E8: [
    { first: '+0,014', second: '+0,028' },
    { first: '+0,020', second: '+0,038' },
    { first: '+0,025', second: '+0,047' },
    { first: '+0,032', second: '+0,059' },
    { first: '+0,040', second: '+0,073' },
    { first: '+0,050', second: '+0,089' },
    { first: '+0,060', second: '+0,106' },
    { first: '+0,072', second: '+0,126' },
    { first: '+0,085', second: '+0,148' },
    { first: '+0,100', second: '+0,172' },
  ],
  E9: [
    { first: '+0,014', second: '+0,039' },
    { first: '+0,020', second: '+0,050' },
    { first: '+0,025', second: '+0,061' },
    { first: '+0,032', second: '+0,075' },
    { first: '+0,040', second: '+0,092' },
    { first: '+0,050', second: '+0,112' },
    { first: '+0,060', second: '+0,134' },
    { first: '+0,072', second: '+0,159' },
    { first: '+0,085', second: '+0,185' },
    { first: '+0,100', second: '+0,215' },
  ],
  F7: [
    { first: '+0,006', second: '+0,016' },
    { first: '+0,010', second: '+0,022' },
    { first: '+0,013', second: '+0,028' },
    { first: '+0,016', second: '+0,034' },
    { first: '+0,020', second: '+0,041' },
    { first: '+0,025', second: '+0,050' },
    { first: '+0,030', second: '+0,060' },
    { first: '+0,036', second: '+0,071' },
    { first: '+0,043', second: '+0,083' },
    { first: '+0,050', second: '+0,096' },
  ],
  F8: [
    { first: '+0,006', second: '+0,020' },
    { first: '+0,010', second: '+0,028' },
    { first: '+0,013', second: '+0,035' },
    { first: '+0,016', second: '+0,043' },
    { first: '+0,020', second: '+0,053' },
    { first: '+0,025', second: '+0,064' },
    { first: '+0,030', second: '+0,076' },
    { first: '+0,036', second: '+0,090' },
    { first: '+0,043', second: '+0,106' },
    { first: '+0,050', second: '+0,122' },
  ],
  F9: [
    { first: '+0,006', second: '+0,031' },
    { first: '+0,010', second: '+0,040' },
    { first: '+0,013', second: '+0,049' },
    { first: '+0,016', second: '+0,059' },
    { first: '+0,020', second: '+0,072' },
    { first: '+0,025', second: '+0,087' },
    { first: '+0,030', second: '+0,104' },
    { first: '+0,036', second: '+0,123' },
    { first: '+0,043', second: '+0,143' },
    { first: '+0,050', second: '+0,165' },
  ],
  G6: [
    { first: '+0,002', second: '+0,008' },
    { first: '+0,004', second: '+0,012' },
    { first: '+0,005', second: '+0,014' },
    { first: '+0,006', second: '+0,017' },
    { first: '+0,007', second: '+0,020' },
    { first: '+0,009', second: '+0,025' },
    { first: '+0,010', second: '+0,029' },
    { first: '+0,012', second: '+0,034' },
    { first: '+0,014', second: '+0,039' },
    { first: '+0,015', second: '+0,044' },
  ],
  G7: [
    { first: '+0,002', second: '+0,012' },
    { first: '+0,004', second: '+0,016' },
    { first: '+0,005', second: '+0,020' },
    { first: '+0,006', second: '+0,024' },
    { first: '+0,007', second: '+0,028' },
    { first: '+0,009', second: '+0,034' },
    { first: '+0,010', second: '+0,040' },
    { first: '+0,012', second: '+0,047' },
    { first: '+0,014', second: '+0,054' },
    { first: '+0,015', second: '+0,061' },
  ],
  H6: [
    { first: '0,000', second: '+0,006' },
    { first: '0,000', second: '+0,008' },
    { first: '0,000', second: '+0,009' },
    { first: '0,000', second: '+0,011' },
    { first: '0,000', second: '+0,013' },
    { first: '0,000', second: '+0,016' },
    { first: '0,000', second: '+0,019' },
    { first: '0,000', second: '+0,022' },
    { first: '0,000', second: '+0,025' },
    { first: '0,000', second: '+0,029' },
  ],
  H7: [
    { first: '0,000', second: '+0,010' },
    { first: '0,000', second: '+0,012' },
    { first: '0,000', second: '+0,015' },
    { first: '0,000', second: '+0,018' },
    { first: '0,000', second: '+0,021' },
    { first: '0,000', second: '+0,025' },
    { first: '0,000', second: '+0,030' },
    { first: '0,000', second: '+0,035' },
    { first: '0,000', second: '+0,040' },
    { first: '0,000', second: '+0,046' },
  ],
  H8: [
    { first: '0,000', second: '+0,014' },
    { first: '0,000', second: '+0,018' },
    { first: '0,000', second: '+0,022' },
    { first: '0,000', second: '+0,027' },
    { first: '0,000', second: '+0,033' },
    { first: '0,000', second: '+0,039' },
    { first: '0,000', second: '+0,046' },
    { first: '0,000', second: '+0,054' },
    { first: '0,000', second: '+0,063' },
    { first: '0,000', second: '+0,072' },
  ],
  H9: [
    { first: '0,000', second: '+0,025' },
    { first: '0,000', second: '+0,030' },
    { first: '0,000', second: '+0,036' },
    { first: '0,000', second: '+0,043' },
    { first: '0,000', second: '+0,052' },
    { first: '0,000', second: '+0,062' },
    { first: '0,000', second: '+0,074' },
    { first: '0,000', second: '+0,087' },
    { first: '0,000', second: '+0,100' },
    { first: '0,000', second: '+0,115' },
  ],
  H10: [
    { first: '0,000', second: '+0,040' },
    { first: '0,000', second: '+0,048' },
    { first: '0,000', second: '+0,058' },
    { first: '0,000', second: '+0,070' },
    { first: '0,000', second: '+0,084' },
    { first: '0,000', second: '+0,100' },
    { first: '0,000', second: '+0,120' },
    { first: '0,000', second: '+0,140' },
    { first: '0,000', second: '+0,160' },
    { first: '0,000', second: '+0,185' },
  ],
  J6: [
    { first: '-0,004', second: '+0,002' },
    { first: '-0,003', second: '+0,005' },
    { first: '-0,004', second: '+0,005' },
    { first: '-0,005', second: '+0,006' },
    { first: '-0,005', second: '+0,008' },
    { first: '-0,006', second: '+0,010' },
    { first: '-0,006', second: '+0,013' },
    { first: '-0,006', second: '+0,016' },
    { first: '-0,007', second: '+0,018' },
    { first: '-0,007', second: '+0,022' },
  ],
  J7: [
    { first: '-0,006', second: '+0,004' },
    { first: '-0,006', second: '+0,006' },
    { first: '-0,007', second: '+0,008' },
    { first: '-0,008', second: '+0,010' },
    { first: '-0,009', second: '+0,012' },
    { first: '-0,011', second: '+0,014' },
    { first: '-0,012', second: '+0,018' },
    { first: '-0,013', second: '+0,022' },
    { first: '-0,014', second: '+0,026' },
    { first: '-0,016', second: '+0,030' },
  ],
  J8: [
    { first: '-0,008', second: '+0,006' },
    { first: '-0,008', second: '+0,010' },
    { first: '-0,010', second: '+0,012' },
    { first: '-0,012', second: '+0,015' },
    { first: '-0,013', second: '+0,020' },
    { first: '-0,015', second: '+0,024' },
    { first: '-0,018', second: '+0,028' },
    { first: '-0,020', second: '+0,034' },
    { first: '-0,022', second: '+0,041' },
    { first: '-0,025', second: '+0,047' },
  ],
  J9: [
    { first: '-0,013', second: '+0,012' },
    { first: '-0,015', second: '+0,015' },
    { first: '-0,018', second: '+0,018' },
    { first: '-0,022', second: '+0,021' },
    { first: '-0,026', second: '+0,026' },
    { first: '-0,031', second: '+0,031' },
    { first: '-0,037', second: '+0,037' },
    { first: '-0,044', second: '+0,043' },
    { first: '-0,050', second: '+0,050' },
    { first: '-0,058', second: '+0,057' },
  ],
  K6: [
    { first: '-0,006', second: '0,000' },
    { first: '-0,006', second: '+0,002' },
    { first: '-0,007', second: '+0,002' },
    { first: '-0,009', second: '+0,002' },
    { first: '-0,011', second: '+0,002' },
    { first: '-0,013', second: '+0,003' },
    { first: '-0,015', second: '+0,004' },
    { first: '-0,018', second: '+0,004' },
    { first: '-0,021', second: '+0,004' },
    { first: '-0,024', second: '+0,005' },
  ],
  K7: [
    { first: '-0,010', second: '0,000' },
    { first: '-0,009', second: '+0,003' },
    { first: '-0,010', second: '+0,005' },
    { first: '-0,012', second: '+0,006' },
    { first: '-0,015', second: '+0,006' },
    { first: '-0,018', second: '+0,007' },
    { first: '-0,021', second: '+0,009' },
    { first: '-0,025', second: '+0,010' },
    { first: '-0,028', second: '+0,012' },
    { first: '-0,033', second: '+0,013' },
  ],
  M6: [
    { first: '', second: '' },
    { first: '-0,009', second: '-0,001' },
    { first: '-0,012', second: '-0,003' },
    { first: '-0,015', second: '-0,004' },
    { first: '-0,017', second: '-0,004' },
    { first: '-0,020', second: '-0,004' },
    { first: '-0,024', second: '-0,005' },
    { first: '-0,028', second: '-0,008' },
    { first: '-0,033', second: '-0,008' },
    { first: '-0,037', second: '-0,008' },
  ],
  M7: [
    { first: '', second: '' },
    { first: '-0,012', second: '0,000' },
    { first: '-0,015', second: '0,000' },
    { first: '-0,018', second: '0,000' },
    { first: '-0,021', second: '0,000' },
    { first: '-0,025', second: '0,000' },
    { first: '-0,030', second: '0,000' },
    { first: '-0,035', second: '0,000' },
    { first: '-0,040', second: '0,000' },
    { first: '-0,046', second: '0,000' },
  ],
  N6: [
    { first: '-0,010', second: '-0,004' },
    { first: '-0,013', second: '-0,005' },
    { first: '-0,016', second: '-0,007' },
    { first: '-0,020', second: '-0,009' },
    { first: '-0,024', second: '-0,011' },
    { first: '-0,028', second: '-0,012' },
    { first: '-0,032', second: '-0,014' },
    { first: '-0,038', second: '-0,016' },
    { first: '-0,045', second: '-0,020' },
    { first: '-0,051', second: '-0,022' },
  ],
  N7: [
    { first: '', second: '' },
    { first: '-0,016', second: '-0,004' },
    { first: '-0,019', second: '-0,004' },
    { first: '-0,023', second: '-0,005' },
    { first: '-0,028', second: '-0,007' },
    { first: '-0,033', second: '-0,008' },
    { first: '-0,039', second: '-0,009' },
    { first: '-0,045', second: '-0,010' },
    { first: '-0,052', second: '-0,012' },
    { first: '-0,060', second: '-0,014' },
  ],
  N8: [
    { first: '', second: '' },
    { first: '-0,020', second: '-0,002' },
    { first: '-0,025', second: '-0,003' },
    { first: '-0,030', second: '-0,003' },
    { first: '-0,036', second: '-0,003' },
    { first: '-0,042', second: '-0,003' },
    { first: '-0,050', second: '-0,004' },
    { first: '-0,058', second: '-0,004' },
    { first: '-0,067', second: '-0,004' },
    { first: '-0,077', second: '-0,005' },
  ],
  P7: [
    { first: '-0,016', second: '-0,006' },
    { first: '-0,020', second: '-0,008' },
    { first: '-0,024', second: '-0,009' },
    { first: '-0,029', second: '-0,011' },
    { first: '-0,035', second: '-0,014' },
    { first: '-0,042', second: '-0,017' },
    { first: '-0,051', second: '-0,021' },
    { first: '-0,059', second: '-0,024' },
    { first: '-0,068', second: '-0,028' },
    { first: '-0,079', second: '-0,033' },
  ],
  P9: [
    { first: '', second: '' },
    { first: '-0,042', second: '-0,012' },
    { first: '-0,051', second: '-0,015' },
    { first: '-0,061', second: '-0,018' },
    { first: '-0,074', second: '-0,022' },
    { first: '-0,088', second: '-0,026' },
    { first: '-0106', second: '-0,032' },
    { first: '-0,124', second: '-0,037' },
    { first: '-0,143', second: '-0,043' },
    { first: '-0,165', second: '-0,050' },
  ],
  R7: [
    { first: '-0,020', second: '-0,010' },
    { first: '-0,023', second: '-0,011' },
    { first: '-0,028', second: '-0,013' },
    { first: '-0,034', second: '-0,016' },
    { first: '-0,041', second: '-0,020' },
    { first: '-0,050', second: '-0,025' },
    { first: '-0,062', second: '-0,030' },
    { first: '-0,076', second: '-0,038' },
    { first: '-0,093', second: '-0,048' },
    { first: '-0,113', second: '-0,060' },
  ],
  S7: [
    { first: '-0,024', second: '-0,014' },
    { first: '-0,027', second: '-0,015' },
    { first: '-0,032', second: '-0,017' },
    { first: '-0,039', second: '-0,021' },
    { first: '-0,048', second: '-0,027' },
    { first: '-0,059', second: '-0,034' },
    { first: '-0,078', second: '-0,042' },
    { first: '-0,101', second: '-0,058' },
    { first: '-0,133', second: '-0,077' },
    { first: '-0,169', second: '-0,105' },
  ],
};
